import { create } from "zustand";

const useHeaderSelectedAIModel = create((set, get) => ({
  selectedModel: null,
  collaboratorModelUpdate: null,
  setSelectedModel: (model) => {
    set({ selectedModel: model });
  },
  setCollaboratorModelUpdate: (update) => {
    set({ collaboratorModelUpdate: update });
  },
  clearCollaboratorModelUpdate: () => {
    set({ collaboratorModelUpdate: null });
  },
  getSelectedModel: () => get().selectedModel,
}));

export default useHeaderSelectedAIModel;
